import React from 'react';
import ReactDOM from 'react-dom';

import Section from './react-components/section';
import ProductList from './react-components/product-list';
import IndustryList from './react-components/industry-list';
import FaqList from './react-components/faq-list';
import TestimonialList from './react-components/testimonial-list';

if( document.getElementById('products') !== null) {

    ReactDOM.render(
        <Section api_url={wp_core.rest.products}>
            <ProductList />
        </Section>, document.getElementById('products')
      );
}

if( document.getElementById('industries') !== null) {
    ReactDOM.render(
        <Section api_url={wp_core.rest.industries}>
            <IndustryList/>
        </Section>, document.getElementById('industries')
      );
}

if( document.getElementById('faq') !== null) {
    ReactDOM.render(
        <Section api_url={wp_core.rest.faq}>
            <FaqList />
        </Section>, document.getElementById('faq')
      );
}

if( document.getElementById('testimonials') !== null) {
    ReactDOM.render(
        <Section api_url={wp_core.rest.testimonials}>
            <TestimonialList />
        </Section>, document.getElementById('testimonials')
      );
}



// document.querySelector('.banner--home').addEventListener('click', function() {

// 	document.querySelector('.section--products').scrollIntoView({ 
//         behavior: 'smooth',
// 	});

// });